import { mapGetters } from 'vuex';
import CommonMixin from '@/mixins/templates/common';

export default {
  mixins : [CommonMixin],
  props  : {
    isOpen: {
      type     : Boolean,
      default  : false,
      required : true
    }
  },
  computed: {
    ...mapGetters({
      getterInstitutionConfiguration: 'plataforma/institutionConfiguration/getterInstitutionConfiguration'
    })
  }
};
